import { ApiBlueprint, createFrontendModule } from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { SignInPage } from '@backstage/core-components';
import { createApiFactory, gitlabAuthApiRef } from '@backstage/core-plugin-api';
import { ScmAuth, scmAuthApiRef, scmIntegrationsApiRef } from '@backstage/integration-react';

const GitlabSignInPage = SignInPageBlueprint.make({
  params: {
    loader: async () =>
      function GitlabSignIn(props) {
        return (
          <SignInPage
            {...props}
            auto
            provider={{
              id: 'gitlab-auth-provider',
              title: 'GitLab',
              message: 'Sign in using GitLab',
              apiRef: gitlabAuthApiRef,
            }}
          />
        );
      },
  },
});

// Backs `requestUserCredentials` on scaffolder repo picker fields (e.g. RepoUrlPicker,
// GitlabSpaceRepoPicker), letting them request a scoped GitLab token on behalf of the
// signed-in user for commits/merge requests made during template execution.
//
// ScmAuth.createDefaultApiFactory() hardcodes its GitLab provider to host
// `gitlab.com`, so it can never match this platform's self-managed GitLab
// (`gitlab.platform-engineering.com`) - every request fails with "No auth
// provider available for '<url>'". Build the GitLab provider(s) from
// whatever hosts are actually configured under `integrations.gitlab`
// instead, so it works for every configured host, not just gitlab.com.
const scmAuthApi = ApiBlueprint.make({
  params: defineParams =>
    defineParams(
      createApiFactory({
        api: scmAuthApiRef,
        deps: {
          gitlabAuthApi: gitlabAuthApiRef,
          scmIntegrationsApi: scmIntegrationsApiRef,
        },
        factory: ({ gitlabAuthApi, scmIntegrationsApi }) =>
          ScmAuth.merge(
            ...scmIntegrationsApi.gitlab
              .list()
              .map(({ config }) =>
                ScmAuth.forGitlab(gitlabAuthApi, { host: config.host }),
              ),
          ),
      }),
    ),
});

export const authModule = createFrontendModule({
  pluginId: 'app',
  extensions: [GitlabSignInPage, scmAuthApi],
});
